<template>
  <v-card outlined>
    <v-data-table
      :loading="loading"
      :items="missing"
      :headers="headers"
      disable-pagination
      hide-default-footer
      :search="filter.search"
      mobile-breakpoint="0"
      multi-sort
    />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogMissingTemplates',
  components: {},
  data: () => {
    return {
      headers: [
        { text: 'Category', value: 'category.name' },
        { text: 'Design Group', value: 'designGroup.nameHierarchy' },
        { text: 'Score', value: 'score' },
        { text: 'All', value: 'templates' },
        { text: 'Vertical', value: 'newTemplates' },
        { text: 'Limit', value: 'limit' },
        { text: 'Needed', value: 'needed' }
      ],
      loading: false
    };
  },
  computed: {
    filter: {
      get() {
        return this.$store.getters['catalog/filter'];
      },
      set(val) {
        this.$store.dispatch('catalog/filter', val);
      }
    },
    ...mapGetters({
      missing: 'templates/missing'
    })
  },
  mounted() {
    this.loading = true;
    Promise.all([
      this.$store.dispatch('templates/loadMissing', this.filter),
      this.$store.dispatch('catalog/filter', Object.assign(this.filter, {}))
    ])
      .catch((error) => {
        this.logError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
